<template>
	<App title="Create Stock Record">
	
		
		
		
		<div class="w-100 position-relative">
			<Block type="form" class="w-75 mx-auto">
			<template #header>
				<h3 class="block-title">Create Stock</h3>
			</template>
			<div class="row">
				<div class="col-12">
					<Form ref="form" @submit="onSubmit">
						<div class="row">
							<div class="lh-sm mb-4">
								<h6 class="text-uppercase mb-0 ">
									<i class="fa fa-user"></i>
									Stock Information
									
								</h6>
								
							</div>
							<div class="col-12 mb-4">
								<InputField id="serial_number" v-model="serial" name="serial" rules="required" label="Serial Number" placeholder="Engine Serial Number" />
							</div>
                            <div class="col-12 col-md-6">
                                <SelectField id="type" v-model="type" name="type" rules="required" label="Station Type" :options="type_options">
									<option v-for="type in types" :key="type.name" :value="type.value">{{ type.value }}</option>
								</SelectField>
                            </div>
                            <div class="col-12 col-md-6">
                                <SelectField id="warehouse" v-model="warehouse" name="warehouse" rules="required" label="Warehouse" :options="warehouse_options" />
                            </div>
							
                            <!----
							<div class="col-12">
                                <h6 class="text-uppercase mb-0 text-sm font-bold ms-2 ">Engine Status</h6>

                                <div class="d-md-flex justify-content-start align-items-center gap-2 mb-4">
                                    <RadioField
                                        v-model="status"
                                        name="status"
                                        rules="required"
                                        label="Engine Status"
                                        :options="types"
                                        />

                                </div>
                                
							</div>
                        -->
							
							
						</div>
						<div class="row">
							<!--submit button-->
								<div class="col-12">
									<div class="d-grid gap-2 d-md-flex justify-content-md-end">
										<button type="button" class="btn bg-danger text-light me-1 mb-3" @click="goBack">Cancel</button>
										<Button id="action" type="submit" :label="label" :loading="loading" :done="done" class="btn bg-secondary text-white me-1 mb-3"/>
				
										
									</div>
								</div>
						<!--end submit button-->
						</div>
					</Form>
				</div>
			</div>
		</Block>
		<div class="mt-9 position-absolute top-0 end-0 ">
			
			<Notivue v-slot="item">
				<Notification :item="item" :theme="materialTheme">
					<NotificationProgress :item="item"/>
				</Notification>
			</Notivue>
		</div>
	</div>
		

		
	</App>
</template>
<script lang="ts">
import Alert from '@/vue/components/Alert.vue'
import Block from '@/vue/components/Block.vue'
import Button from '@/vue/components/Button.vue'
import Form from '@/vue/components/Form.vue'
import InputField from '@/vue/components/InputField.vue'
import SelectField from '@/vue/components/SelectField.vue'
import { Notivue, Notification, push, materialTheme, NotificationProgress } from 'notivue'
import $ from 'jquery'
import { Options as Select2Options } from 'select2'
//import RadioField from '@/vue/components/RadioField'

import App from '@/vue/templates/App.vue'
import { ButtonLabel } from '@/vue/utils/Button'
import { Component, Ref, toNative, Vue, Watch, Prop } from 'vue-facing-decorator'

@Component({
	components: {
		Block,
		Form,
		InputField,
		Button,
		Alert,
		App,
		Notivue,
		Notification,
		NotificationProgress,
        SelectField
     // RadioField
		
	},
})
class Update extends Vue {
	loading = false
	done = false
	message = ''
    type = ''
    warehouse = ''
	//engine_number = ''
	serial = ''
	status = 'none'
	materialTheme = materialTheme
	
	
	@Ref('form')
	readonly form!: InstanceType<typeof Form>

	@Ref('alert')
	readonly alert!: InstanceType<typeof Alert>
    
    @Prop({ type: Array })
	readonly types!: Array<{ name: string; value: string }>
	@Prop({type:Object})
	readonly stock


	@Watch('message')
	onMessageChanged(value: string) {
		if (value.length > 0) {
			this.alert.show()
		} else {
			this.alert.hide()
		}
	}

	get label(): ButtonLabel {
		return {
			normal: 'Update Stock',
			loading: 'Updating....',
			done: 'Stock updated ',
		}
	}

    get type_options(): Select2Options {
		return {
			placeholder: 'Select Stock Type',
			minimumResultsForSearch: Infinity,
			//@ts-ignore
			ajax: null,
		}
	}
	get warehouse_options(): Select2Options {
		return {
			placeholder: 'Select Warehouse',
			minimumResultsForSearch: Infinity,
			ajax: {
				method: 'get',
				url: this.route('warehouse.ajax.select.warehouse'),
			},
			//@ts-ignore
			templateResult: ({ id, title, text }) => (id ? $(`<span>${title}</span>`) : text),
			//@ts-ignore
			templateSelection: ({ id, title, text }) => (id ? $(`<span>${title}</span>`) : text),
		}
	}
	created(){
		this.serial = this.stock.serial
		this.$nextTick(()=> 
			setTimeout(()=>{
				this.type = this.stock.type
				this.warehouse = this.stock.warehouse.id
			},500)
		)
	}
	onSubmit(payload) {
		this.loading = true
		this.$http
			.put(this.route('stock.ajax.update',{stock : this.stock.id}), payload)
			.then((response) => {
				this.done = true
				this.message = response?.data?.message || 'Stock updated successfully.'
				push.success({
				title: 'status',
				message: this.message
				})
				setTimeout(()=>{
					this.router.visit(this.route('stock.page.group'))
				},6000)
				
				
			})
			.catch((e) => {
				this.message = e.response?.data?.message || 'An error occurred.'
				push.error({
				title: 'status',
				message: this.message
				})
			})
			.finally(() => (this.loading = false))
	}

	goBack() {
		window.history.back()
	}
}

export default toNative(Update)
</script>
